// computed.js
import moment from "moment";
moment.locale("pt-br");

export default {
  // Regras específicas para semanas - fácil de modificar e adicionar novas
  // Formato: "YYYY-MM": { numeroSemana: { inicio: "DD/MM", fim: "DD/MM" } }
  regrasEspeciais: {
    "2025-10": { // Outubro 2025
      4: { inicio: "27/10", fim: "30/10" }
    },
    "2025-11": { // Novembro 2025
      1: { inicio: "31/10", fim: "09/11" },
      3: { inicio: "17/11", fim: "25/11" },
      4: { inicio: "26/11", fim: "30/11" }
    },
    "2026-10": { // Outubro 2026
      5: { inicio: "26/10", fim: "29/10" }
    },
    "2026-11": { // Novembro 2026
      1: { inicio: "30/10", fim: "08/11" },
      3: { inicio: "16/11", fim: "24/11" },
      4: { inicio: "25/11", fim: "29/11" }
    }
  },

  // Verifica se existe regra especial para o mês
  temRegraEspecial(mes) {
    const chave = moment(mes).format("YYYY-MM");
    return this.regrasEspeciais[chave];
  },

  calculaSemanas(mes) {
    const primeiroDiaMes = moment(mes).startOf("month");
    const ultimoDiaMes = moment(mes).endOf("month");

    // Cálculo padrão
    const primeiroDiaIso = moment(primeiroDiaMes).isoWeekday();
    const ultimoDiaIso = moment(ultimoDiaMes).isoWeekday();

    let inicio;
    if (primeiroDiaIso >= 5) {
      const diasAdicionar = 8 - primeiroDiaIso;
      inicio = moment(primeiroDiaMes).add(diasAdicionar, "days");
    } else {
      inicio = moment(primeiroDiaMes).startOf("isoWeek");
    }
    let fim;
    if (ultimoDiaIso >= 4) {
      fim = moment(ultimoDiaMes).endOf("isoWeek");
    } else {
      fim = moment(ultimoDiaMes).subtract(ultimoDiaIso, "days");
    }

    const semanas = [];
    let semana = 1;
    while (inicio.isSameOrBefore(fim)) {
      semanas.push({
        mes: moment(mes).format("YYYY-MM-DD"),
        semana: semana,
        inicio: inicio,
        fim: moment(inicio).add(6, "days")
      });
      inicio = moment(inicio).add(7, "days");
      semana++;
    }

    // Aplica regras especiais substituindo as semanas
    const regras = this.temRegraEspecial(mes);
    if (regras) {
      const ano = moment(mes).year();
      semanas.forEach(semanaObj => {
        const regraParaSemana = regras[semanaObj.semana];
        if (regraParaSemana) {
          semanaObj.inicio = moment(`${regraParaSemana.inicio}/${ano}`, "DD/MM/YYYY");
          semanaObj.fim = moment(`${regraParaSemana.fim}/${ano}`, "DD/MM/YYYY");
        }
      });
    }

    return semanas;
  },
  calculaSemanaPeriodo(primeiroDia, ultimoDia) {
    

    const diaInicial = moment(primeiroDia)
    const diaFinal = moment(ultimoDia)
    const primeiroDiaMesIncio = moment(primeiroDia).startOf("month").subtract(1,'month')
    const prmeiroDiaMesFinal = moment(ultimoDia).startOf("month").add(1,'month')
    
    let semanas = []
    while (primeiroDiaMesIncio.isSameOrBefore(prmeiroDiaMesFinal)) {
        semanas.push(...this.calculaSemanas(primeiroDiaMesIncio))
        primeiroDiaMesIncio.add(1,"month")
    }

    const semanasEleitas = semanas.filter(semana => {
        return semana.fim.isSameOrAfter(diaInicial) && semana.inicio.isSameOrBefore(diaFinal)
    })

    return semanasEleitas
  }
};
